/**
 * @desc: - 投注选号 - 全/大/小/奇/偶/清操作
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} type:         [类型：dice 常规, dice_relation 互斥]
 * @param  {[STRING]} items:        [选项: 数据来源selectarea.layout]
 * @param  {[STRING]} values:       [当前选中值]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: klaf
 */
export default class BetDice extends React.Component {

	constructor(props) {
		super(props);
    this.makeDisplay = this.makeDisplay.bind(this)
	}

	// 点击
	handleClick(selectValue, index){
    const {type, items, values, onChange} = this.props;
    let result = null;
    
    // 点击选择区
    if(selectValue.checked){
      result = _.remove(values[index], function(n){
        return n != selectValue.code
      })
    }else{

      // 没有选
      result = _.sortBy(_.concat(values[index], selectValue.code))
      
      // 互斥
      if(type=='dice_relation'){
        if(values[1-index] && values[1-index].length>0 && _.includes(values[1-index], selectValue.code)){
          let newvalue = _.remove(values[1-index], function(n){
            return n == selectValue.code
          })
          onChange(newvalue, 1-index);
        }
      }

      // 胆拖，三不同胆最多只能选两个，二不同胆最多只能选一个
      if(selectValue.maxchosen && selectValue.maxchosen>0){
        if( index==0 && (result.length > selectValue.maxchosen) ){
          let newvalue = result.splice(result.indexOf(values[0][0]), 1);
          onChange(newvalue, 0);
        }
      }

    }
    
    onChange(result, index);
	}

	// 组装显示结果
	makeDisplay(items, values){
    const displayList = [];
    _.forEach(items, function(item, index){
      displayList[index] = [];
      _.forEach(item.no.split('|'), function(it){
        let code = it.substr(0,1);
        let starIndex = it.indexOf('*');
        let hClassName = 'h65',liClassName = 'single';
        if(it.length>=2){
          hClassName = 'h100';
          liClassName = 'double';
        }
        if(it.length>=3){
          hClassName = 'h150';
          liClassName = 'triple';
          item.title = '';
        }
        let eachItem = {
          display: it,
          code: code,
          checked: _.includes(values[index], code),
          liClassName:liClassName,
          hClassName:hClassName,
          title:item.title,
          maxchosen:item.maxchosen?item.maxchosen:0,
          starIndex:starIndex
        }
        displayList[index].push(eachItem);
      })
    })
    return displayList
	}

	render() {
		const {className, type, items, values, onChange} = this.props;
    const displayList = this.makeDisplay(items, values);

    return (
      <div className={className?className:'lotteryView_k3'}>
        {
          displayList.map((item, indexp)=>{
            return <div className={item[0].hClassName} key={indexp}>
              <h3>{item[0].title}</h3>
              <ul>
                {
                  item.map((it, index)=>{
                    return <li key={index} className={it.checked?(it.liClassName+" hover"):it.liClassName} onClick={this.handleClick.bind(this, it, indexp)}>
                      <em>{it.code}</em>
                      {( it.liClassName=='triple' && (it.starIndex==-1) ) ? <span className={'s'+it.code+' mar'}></span> : ( ( it.liClassName=='triple' && (it.starIndex>-1) ) ? <span className="s7 mar"></span> : '' )}
                      {it.liClassName=='triple'?<span className={'s'+it.code}></span>:''}
                      {it.liClassName=='double'?<span className={'s'+it.code}></span>:''}
                      <span className={'s'+it.code}></span>
                      {it.liClassName=='triple'?<p>{it.display}</p>:''}
                    </li>
                  })
                }
              </ul>
            </div>
          })
        }
      </div>
    )
	}
}
